module.exports = __webpack_public_path__ + "static/gumtree-preview.22b8577a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/gumtree/gumtree-preview.jpg
// module id = 466
// module chunks = 23981196639075